import OwlCarousel from "react-owl-carousel";

import Data from "../../data/projects.json";

function Projects({ id }) {
  return (
    <OwlCarousel
      className="owl-theme"
      margin={20}
      nav
      responsive={{
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 3,
        },
      }}
    >
      {Data.map((data) =>
        id == 0 || data.id == id
          ? data.items.map((dataItem) => (
              <div
                className="item d-flex justify-content-center"
                key={dataItem.id}
              >
                <div className="products_slide project-item-slide">
                  <div
                    className={`card-title ${
                      dataItem.title.length > 18 ? "multiline" : ""
                    }`}
                  >
                    <p>{dataItem.title}</p>
                  </div>
                  <picture className="my-4">
                    <img style={{ height: "100px" }}src={dataItem.image} alt="" />
                  </picture>
                  <h5  style={{ fontSize: 14 }} className="mb-3">{dataItem.subtitle}</h5>
                  <p style={{ fontSize: 14 }} className="mb-4">{dataItem.description}</p>
                  <div className="techs">
                    {dataItem.technology.map((tech) => (
                      <p>{tech}</p>
                    ))}
                  </div>
                </div>
              </div>
            ))
          : null
      )}

      {/* <div className="item">
        <div className="products_slide">
          <img src="assets/images/alI-chatbot.png" alt="" />
          <h3>
            <span>AI Chatbot</span>
          </h3>
          <p>
            Artificial intelligence-powered chatbot that can communicate with
            humans in a natural language.project involves designing, developing,
            and deploying a chatbot that can perform specific tasks or answer
            questions for users. The chatbot can be used for various purposes,
            such as customer support, sales, marketing, or personal assistance
          </p>
        </div>
      </div>
      <div className="item">
        <div className="products_slide">
          <img src="assets/images/restaurant-revenue.png" alt="" />
          <h3>
            <span>Restaurant Revenue Prediction</span>
          </h3>
          <p>
            Restaurant revenue prediction project is an initiative to create a
            machine learning model that can forecast the revenue of a restaurant
            based on various factors such as customer footfall, menu items,
            prices, and marketing promotions. The goal of this project is to
            help restaurant owners make data-driven decisions to increase their
            revenue and profitability.
          </p>
        </div>
      </div>
      <div className="item">
        <div className="products_slide">
          <img src="assets/images/face-detection.png" alt="" />
          <h3>
            <span>Face Detection</span>
          </h3>
          <p>
            climate change impacts project on the global food supply is an
            initiative to investigate how climate change will affect food
            production, distribution, and consumption worldwide. The project
            aims to provide insights into how these impacts may vary by region,
            crop type, and socio-economic factors, and to identify potential
            strategies for adaptation and mitigation.
          </p>
        </div>
      </div>
      <div className="item">
        <div className="products_slide">
          <img src="assets/images/alI-chatbot.png" alt="" />
          <h3>
            <span>AI Chatbot</span>
          </h3>
          <p>
            Credit card fraud detection using classification algorithms is an
            initiative to create a machine learning model that can automatically
            detect fraudulent transactions in credit card transactions. The goal
            of this project is to enable financial institutions to detect and
            prevent fraud and protect their customers' financial security.
          </p>
        </div>
      </div>
      <div className="item">
        <div className="products_slide">
          <img src="assets/images/restaurant-revenue.png" alt="" />
          <h3>
            <span>Restaurant Revenue Prediction</span>
          </h3>
          <p>
            Water quality project using the random forest algorithm in data
            science is an initiative to create a machine learning model that can
            predict water quality parameters such as pH, dissolved oxygen,
            biochemical oxygen demand (BOD), and total suspended solids (TSS).
            Predict water quality using datasets.
          </p>
        </div>
      </div> */}
    </OwlCarousel>
  );
}
export default Projects;
